/**
 * Utility module for Admin dashboard API and helpers.
 * @module AdminUtils
 */
import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://localhost:8000'
    : 'https://crapule-bxl-production.up.railway.app'
);

export const API = `${BACKEND_URL}/api`;

export const adminAPI = axios.create({ baseURL: API });
adminAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Resolve media URL to absolute backend URL when needed.
 * @param {string} url Relative or absolute media URL
 * @returns {string} absolute URL
 */
export const mediaSrc = (url) => (url && url.startsWith('http') ? url : `${BACKEND_URL}${url || ''}`);

export default adminAPI;
